import Immutable from 'seamless-immutable';
import * as actionTypes from './actionTypes';

const initialState = Immutable({
  byId: {},
  params: {},
  sent_users: {},
  error: '',
  actionsloading: false
});

export function sendWeeklyEmailsReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SEND_WEEKLY_EMAILS:
    case actionTypes.SAVE_EMAIL_TEXT:
    case actionTypes.GET_WEEKLY_EMAIL_TEXT:
    case actionTypes.UPDATE_EMAIL_TEXT:
      return {
        ...state,
        sent_users: {},
        error: '',
        actionsloading: true
      }
    case actionTypes.GET_WEEKLY_EMAIL_TEXT_SUCCESS:
      return {
        ...state,
        byId: action.payload.byId || {},
        actionsloading: false
      }
    case actionTypes.SEND_WEEKLY_EMAILS_SUCCESS:
      return {
        ...state,
        sent_users: action.payload.byId || {},
        actionsloading: false
      }
    case actionTypes.SEND_WEEKLY_EMAILS_FAILED:
      return {
        ...state,
        error: action.payload,
        actionsloading: false
      }
    case actionTypes.CLEAR_USER_STATE:
      return {
        ...state,
        sent_users: {},
        error: '',
        actionsloading: false
      }
    case actionTypes.SAVE_EMAIL_TEXT_SUCCESS:
    case actionTypes.UPDATE_EMAIL_TEXT_SUCCESS:
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.payload.weeklyemailtextUid]: action.payload
        },
        actionsloading: false
      }
    default:
      return state;
  }
}